'use strict';

AppBootstrapper.$inject = [
  'DomainBootstrapper',
  'ReduxBootstrapper',
];

// Wait for each service that must complete before the app may start
export function AppBootstrapper(
  DomainBootstrapper,
  ReduxBootstrapper,
) {
  const loaded = Promise.all([
    DomainBootstrapper.loaded(),
    ReduxBootstrapper.loaded(),
  ]);

  return {
    loaded: () => loaded,
  };
}



// WEBPACK FOOTER //
// ./src/js/config/AppBootstrapper.js